import axios from "../../axios-config"

// get smart link analytics (pre+post)
export const fetchSmartLinkAnalytics = async ({ smartLinkId, range }) => {
  const res = await axios.get(
    `/artist-manager/v1/get-smartlink-analytics/${smartLinkId}`,
    {
      params: { range },
    }
  );

  return res.data?.data;
};

// get all smartlink list
export const fetchSmartLinkList = async ({ page = 1, limit = 10, type } = {}) => {
  const res = await axios.get("/artist-manager/v1/get-user-smart-link", {
    params: { page, limit, ...(type ? { type } : {}) },
  });

  const data = res.data?.data || {};
  return {
    total: data.total || 0,
    page: data.page || page,
    limit: data.limit || limit,
    smartlinkList: data.linkList || [],
  };
};

// get top three smart link
export const fetchTopThreeSmartLinks = async () => {
  const res = await axios.get(
    "/artist-manager/v1/get-user-smart-link-with-analytics"
  );

  return res.data?.data || [];
};

/* CREATE MUSIC LINK */
export const createMusicLinkApi = async (data) => {
  const res = await axios.post(
    "/artist-manager/v1/create-customize-smartlink",
    data
  );
  return res.data;
};

/* GET SMART LINK DETAILS */
export const fetchSmartLinkDetailsApi = async (smartLinkId) => {
  const res = await axios.get(
    `/artist-manager/v1/get-smartlink-details/${smartLinkId}`
  );
  return res.data?.data;
};

/* UPDATE SMART LINK */
export const updateSmartLinkApi = async ({ smartLinkId, formData }) => {
  const res = await axios.put(
    `/artist-manager/v1/edit-customize-smartlink/${smartLinkId}`,
    formData
  );
  return res.data;
};

// create pre save link
export const createPreSaveSmartLinkApi = async (formData) => {
  const res = await axios.post(
    "/artist-manager/v1/create-presave-smartlink",
    formData
  );
  return res.data;
};

// update pre save link
export const updatePreSaveSmartLinkApi = async ({ id, formData }) => {
  const res = await axios.put(
    `/artist-manager/v1/edit-presave-smartlink/${id}`,
    formData
  );
  return res.data;
};

// get overall smartlink analytics for dashoard
export const fetchOverallLinksAnalyticsApi = async (range) => {
  const res = await axios.get(
    `/artist-manager/v1/get-overall-smartlink-analytics`,
    {
      params: { range },
    }
  );

  return res.data?.data;
};

export const fetchOverallAudience = async ({ page = 1, limit = 10 }) => {
  const res = await axios.get(
    "/artist-manager/v1/get-overall-smartlink-audience",
    { params: { page, limit } }
  );

  return res.data.data;
};


export const downloadOverallAudienceCsvApi = async () => {
  const response = await axios.get(
    "/artist-manager/v1/download-overall-audience-csv",
    {
      responseType: "blob",
    }
  );
  return response.data;
};

// future save
export const getArtistFutureSaveApi = async () => {
  const response = await axios.get(
    "/artist-manager/v1/get-artist-future-save-setting"
  );
  return response.data?.data;
};

export const updateArtistFutureSaveApi = async (payload) => {
  const { data } = await axios.put(
    "/artist-manager/v1/update-artist-future-save",
    payload
  );
  return data.data;
};

export const createBioAndTourLinkApi = async (data) => {
  const res = await axios.post(
    "/artist-manager/v1/create-bio-and-tour-link",
    data
  );
  return res.data;
};

export const suggestMusicShortIdApi = async ({ songTitle, releaseType, autoplayTrackSongName }) => {
  const res = await axios.get(
    "/artist-manager/v1/suggest-music-short-id",
    { params: { songTitle, releaseType, autoplayTrackSongName } }
  );
  return res.data;
};

export const suggestBioShortIdApi = async (title) => {
  const res = await axios.get(
    "/artist-manager/v1/suggest-bio-short-id",
    { params: { title } }
  );
  return res.data;
};

export const checkBioLinkStatusApi = async () => {
  const res = await axios.get(
    "/artist-manager/v1/get-bio-link-status"
  );
  return res.data;
};

export const updateBioAndTourLinkApi = async ({ id, formData }) => {
  const res = await axios.put(
    `/artist-manager/v1/edit-bio-and-tour-link/${id}`,
    formData
  );
  return res.data;
};